/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { LoaderState } from "behaviors/loader/state";
import Spinner from "components/spinner/spinner";
import { t } from "i18n";
import { TimeoutError } from "api/errors";
import Plus from "components/icons/plus";
import Button from "components/button/button";

interface StateProps {
  loader: LoaderState;
  loadCustomMetadata: () => void;
}

type Props = StateProps;

const Loader: React.SFC<Props> = ({ loader: { loading, error }, loadCustomMetadata }) => {
  if (loading) {
    return <Spinner message={t("custom-metadata.loading-list")} />;
  }

  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <Plus width="48" height="48" />
          <p>{t("custom-metadata.messages.could-not-load-list")}</p>
          <p>
            <Button onClick={loadCustomMetadata}>{t("custom-metadata.cta.load-retry")}</Button>
          </p>
        </React.Fragment>
      );
    }
  }

  return <p>{t("custom-metadata.messages.unknown-error")}</p>;
};

export default Loader;
